// Desktop Search Toggle
document.addEventListener( 'DOMContentLoaded', function () {
	const searchToggle = document.getElementById( 'search-toggle' );
	const searchForm = document.getElementById( 'header-search-form' );

	if ( searchToggle && searchForm ) {
		searchToggle.addEventListener( 'click', function () {
			searchForm.classList.toggle( 'active' );
			searchToggle.classList.toggle( 'active' );
		} );
	}
} );

// Close announcement dropdown on outside interaction.
function closeAnnouncementDropdown() {
	const dropdown = document.querySelector( '.announcement-dropdown' );
	if ( ! dropdown ) {
		return;
	}
	const menu = dropdown.querySelector( '.dropdown-menu' );
	const toggle = dropdown.querySelector( '.dropdown-toggle' );

	if ( menu && menu.classList.contains( 'show' ) ) {
		menu.classList.remove( 'show' );
		toggle?.classList.remove( 'show' );
		toggle?.setAttribute( 'aria-expanded', 'false' );
	}
}

document.addEventListener( 'click', function ( event ) {
	const dropdown = document.querySelector( '.announcement-dropdown' );
	if ( dropdown && ! dropdown.contains( event.target ) ) {
		closeAnnouncementDropdown();
	}
} );

window.addEventListener( 'scroll', closeAnnouncementDropdown );

document.addEventListener( 'keydown', function ( event ) {
	if ( event.key === 'Escape' ) {
		closeAnnouncementDropdown();
		return;
	}
	const dropdown = document.querySelector( '.announcement-dropdown' );
	if ( dropdown && ! dropdown.contains( event.target ) ) {
		closeAnnouncementDropdown();
	}
} );

document.addEventListener( 'focusin', function ( event ) {
	const dropdown = document.querySelector( '.announcement-dropdown' );
	if ( dropdown && ! dropdown.contains( event.target ) ) {
		closeAnnouncementDropdown();
	}
} );

// Mobile Search Toggle
document.addEventListener( 'DOMContentLoaded', function () {
	const mobileSearchToggle = document.getElementById( 'mobile-search-toggle' );
	const mobileSearchForm = document.getElementById( 'mobile-search-form' );

	if ( mobileSearchToggle && mobileSearchForm ) {
		mobileSearchToggle.addEventListener( 'click', function () {
			mobileSearchForm.classList.toggle( 'active' );
			mobileSearchToggle.classList.toggle( 'active' );
		} );
	}
} );
